import * as $ from "jquery";

declare const TweenLite: any;
declare const Power1: any;
// const TweenLite = require("gsap").TweenLite;
// const Power1 = require("gsap").Power1;

const ScrollToPlugin = require("../lib/gsap/ScrollToPlugin");


export default class SmoothScroll {
	scrollTime: number;
	scrollDistance: number;

	constructor() {
		this.scrollTime = 0.2;
		this.scrollDistance = 120;

		$(window).on("mousewheel DOMMouseScroll", (event) => {
			const ogEvent = <any> event.originalEvent;

			// Only custom scroll when user is not hovering over an overflow:auto element
			if (!$(ogEvent.target).parents('.modal-content__wrapper').length && !$(ogEvent.target).parents('.select2-container').length) {
				event.preventDefault();

				const delta = ogEvent.wheelDelta / 120 || -ogEvent.detail / 3;
				const scrollTop = $(window).scrollTop();
				const scrollDiff = delta * this.scrollDistance;
				const finalScroll = (scrollTop - scrollDiff).toFixed(0);

				TweenLite.to($(window), this.scrollTime, {
					scrollTo : {
						y: finalScroll,
						autoKill: true
					},
					force3D: false,
					ease: Power1.easeOut,
					autoKill: true,
					overwrite: 5
				});
			}

		});
	}
}